import { IIamSettings } from "../../utils/auth/iamSettings";
import { ActionsUnion, createAction } from "../definitions";
import { IamCredentialsActionTypes } from "./types";

export class IamCredentials {
    user: string;
    iamSettings: IIamSettings;
}

export interface IIamUserPayload {
    userName: string;
    iamSettings: IIamSettings;
    user: string;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const IamCredentialsActions = {
    setUser: (payload: IIamUserPayload) => createAction(IamCredentialsActionTypes.SET_IAM_USER, payload),
    removeUser: (payload: string) => createAction(IamCredentialsActionTypes.REMOVE_IAM_USER, payload)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type IamCredentialsActions = ActionsUnion<typeof IamCredentialsActions>;